import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=48166f57&scoped=true&"
import script from "./Memo.vue?vue&type=script&lang=ts&"
export * from "./Memo.vue?vue&type=script&lang=ts&"
import style0 from "./Memo.vue?vue&type=style&index=0&id=48166f57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48166f57",
  null
  
)

export default component.exports